import { Navigate } from "react-router-dom";
import { routes } from "../utils";
import { AddProjectCategory, AddRole, ProjectCategory, Role } from "@/pages";

export const MasterDataRoutes = () => {
  return {
    path: routes.masterData,
    children: [
      {
        path: "",
        element: (
          <Navigate
            to={`/${routes.admin}/${routes.masterData}/${routes.category}`}
          />
        ),
      },
      {
        path: routes.category,
        children: [
          {
            path: "",
            element: <ProjectCategory />,
          },
          {
            path: routes.add,
            element: <AddProjectCategory />,
          },
        ],
      },
      {
        path: routes.role,
        children: [
          {
            path: "",
            element: <Role />,
          },
          {
            path: routes.add,
            element: <AddRole />,
          },
        ],
      },
    ],
  };
};
